import React, { useEffect } from "react";
import { Modal, Form, Input, Col, Row, message, Upload, Button } from "antd";
import { API_METHODS } from "../../../constants";
import useApi from "../../../hooks/useApi";
import { UploadOutlined } from "@ant-design/icons";

function AddGrampanchayati(props) {
  const [messageApi, contextHolder] = message.useMessage();

  const [form] = Form.useForm();
  const { visible, close, selectedRecord } = props;
  const [response, request] = useApi(
    "/admin/grampanchayati",
    null,
    API_METHODS.POST,
    true
  );
  const [editResponse, editRequest] = useApi(
    `/admin/grampanchayati/${selectedRecord && selectedRecord.id}`,
    null,
    API_METHODS.PUT,
    true
  );

  useEffect(() => {
    if (response.data) {
      close(true);
      messageApi.open({
        type: "success",
        content: "Text added successfully.",
      });
    }
  }, [response]);

  useEffect(() => {
    if (editResponse.data) {
      close(true);
      messageApi.open({
        type: "success",
        content: "Text updated successfully.",
      });
    }
  }, [editResponse]);

  useEffect(() => {
    if (selectedRecord) {
      form.setFieldsValue(selectedRecord);
    }
  }, [selectedRecord]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const formData = new FormData();
        formData.append("text", values.text);
        let files = values.files?.fileList.map((f) => {
          return { originFileObj: f.originFileObj, name: f.name };
        });
        for (let i = 0; i < files?.length; i++) {
          formData.append("files", files[i].originFileObj, files[i].name);
        }

        if (selectedRecord) {
          editRequest(formData);
        } else {
          request(formData);
        }
      })
      .catch((e) => {});
  };

  const handleCancel = () => {
    close();
  };

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  return (
    <Modal
      title={selectedRecord ? "Update Text" : "Add Text"}
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={1000}
      okText="Save"
    >
      {contextHolder}
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="text"
              label="Text"
              rules={[{ required: true, message: "Text is required." }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="files" label="Upload PDF or Images">
              <Upload customRequest={dummyRequest} multiple={true}>
                <Button icon={<UploadOutlined />}>Click to Upload</Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default AddGrampanchayati;
